import { useMutation } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { message } from 'antd';
import { unifiedClient } from '@/lib/unified-fetch';

export type SyncEventToolParams = {
  dateRange: [string, string];
  statusIn?: string[];
};

export function useSyncEventTool() {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: async ({ dateRange, statusIn }: SyncEventToolParams) => {
      const { data, error } = await unifiedClient.admin.POST(
        '/event_Event/sync-event-tool',
        {
          body: {
            startTimeGte: dayjs(dateRange[0]).startOf('day').toISOString(),
            startTimeLte: dayjs(dateRange[1]).endOf('day').toISOString(),
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ...(statusIn && statusIn.length > 0 ? { statusIn: statusIn as any } : {}),
          },
        },
      );
      if (error) throw error;
      return data;
    },
    onSuccess: (result) => {
      message.success(
        `Sync complete — ${result.fetched} fetched, ${result.created} created, ${result.updated} updated.`,
      );
    },
    onError: () => {
      message.error('Failed to sync. Please try again.');
    },
  });
  return { syncEventTool: mutateAsync, isLoading: isPending };
}
